export default __webpack_public_path__ + "static/media/05.e4b1be16.png";